const globalVariables = require('globalVariables');
import userStore from '../stores/userStore';

class FetchDataHelper {

    get(relativeUrl: string, noAuth?: boolean): Promise<void | string> { // fullfiled: nothing, rejected: string
        return this.fetchWithCustomHandling("GET", relativeUrl, null, noAuth).then(() => {}, res => this.onError(res));
    }

    getReturnJson(relativeUrl: string, noAuth?: boolean): Promise<any | string> { // fullfiled: any, rejected: string
        return this.fetchWithCustomHandling("GET", relativeUrl, null, noAuth).then(res => res.json(), res => this.onError(res));
    }

    post(relativeUrl: string, content: any, noAuth?: boolean): Promise<void | string> { // fullfiled: nothing, rejected: string
        return this.fetchWithCustomHandling("POST", relativeUrl, content, noAuth).then(() => {}, res => this.onError(res));
    }

    postReturnJson(relativeUrl: string, content: any, noAuth?: boolean): Promise<any> { // fullfiled: any, rejected: string
       return this.fetchWithCustomHandling("POST", relativeUrl, content, noAuth).then(res => res.json(), res => this.onError(res));
    }

    download(relativeUrl: string, noAuth?: boolean): Promise< any | string> { // fullfiled: any, rejected: string
        return this.fetchWithCustomHandling("GET", relativeUrl, null, noAuth).then(res => this.downloadBlob(res), res => this.onError(res));
    }

    delete(relativeUrl: string, noAuth?: boolean): Promise<void | string> { // fullfiled: nothing, rejected: string
        return this.fetchWithCustomHandling("DELETE", relativeUrl, null, noAuth).then(() => {}, res => this.onError(res));
    }

    // status code 200 - fullfiled. Otherwise - rejected
    fetchWithCustomHandling( method: string, relativeUrl: string, content: any, noAuth?: boolean ): Promise<Response> {
        var uri = globalVariables.apiUrl + relativeUrl;
        var options = this.getOptions(method, content, noAuth);
        var logPrefix = 'HTTP ' + method + ' fetch to url ' + relativeUrl + ': ';
        
        return fetch(uri, options).then(
           (response) => {
               // fullfiled invoked for every status code
                if (response.status == 401 && !uri.toString().includes('/user/'))
                {
                    console.log(logPrefix + "Unauthorized - refreshing token...")
                    return userStore.refreshToken().then(
                        () => {
                            console.log(logPrefix + 'Refresh token call fullfiled.');
                            console.log(logPrefix + 'Retrying the original HTTP request...');
                            options = this.getOptions(method, content, noAuth); // use new JWT token
                            return fetch(uri, options).then(
                                (response) => {
                                   
                                    if (response.status == 401){
                                        console.log(logPrefix + 'Unauthorized - logout.');
                                        userStore.logoutNoRevoke();
                                        return Promise.reject(response);
                                    }

                                    if (response.status != 200){
                                        return Promise.reject(response);
                                    }

                                    return response;
                                },
                                (response) => {
                                    console.log(logPrefix + 'Retry of the original HTTP request rejected - logout.');
                                    userStore.logout();
                                    return Promise.reject(response);
                                }
                            )
                        },
                        () => {
                            console.log(logPrefix + 'Refresh token call rejected');
                            //userStore.logout(); -- refresh token will do logout
                            return Promise.reject(response);
                        }
                    )
                }

                if (response.status == 401 && uri.toString().includes('/user/')){ // revoke is the only action with auth
                    userStore.logoutNoRevoke();
                    return Promise.reject(response);
                }

                if (response.status != 200){
                    return Promise.reject(response);
                }
            
                return response;
            },
            (response) => { 
                console.log(logPrefix + 'Fetch operation rejected. Response to inspect:');
                console.log(response);
                return Promise.reject(response);
            }
       );
    }
    
    getHeaders(): HeadersInit {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + window.localStorage.getItem('jwt')
        };
    } 

    getHeadersNoAuth(): HeadersInit{
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
    } 

    getOptions(method: string, content: any, noAuth?: boolean): RequestInit {
        var headers = noAuth == true ? this.getHeadersNoAuth() : this.getHeaders();

        return {
            method: method,
            headers: headers,
            body: content != null ? JSON.stringify(content) : null
        }
    }

    onError(response: Response): Promise<string> {
        return response.text().then(text => Promise.reject(this.formatError(text)), () => Promise.reject('Unknown error occurred'));
    }

    formatError(message: string = ''): string {
        if (message == '')
            message = 'Unknown error occurred';
        return this.replaceAll(message, '\"', '');
    }

    replaceAll(text: string, find: string, replace: string) {
        return text.replace(new RegExp(find, 'g'), replace);
    }

    downloadBlob(response: any){

        const header = response.headers.get('Content-Disposition');
        const parts = header!.split(';');
        const fileName = parts[1].split('=')[1];

        response.blob().then((blob: any) => {
            var file = window.URL.createObjectURL(blob as Blob);

            const link = document.createElement('a');
            link.href = file;
            link.setAttribute('download', fileName);
            
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        });
    }
}

export default new FetchDataHelper();